export default {
        checkEmail:function(email) {
            return String(email)
            .toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        },

        changeTimeFormat: (dateString, format, delimiter = '-') => {
          if (!dateString) return null

          const date = new Date(dateString)
          const year = date.getFullYear() // 取得年份
          let month = date.getMonth() + 1 // 取得月份
          month = month < 10 ? `0${month}` : month
          let day = date.getDate() // 取得日期
          day = day < 10 ? `0${day}` : day
          let hours = date.getHours() // 取得小時
          hours = hours < 10 ? `0${hours}` : hours
          let minutes = date.getMinutes() // 取得分鐘
          minutes = minutes < 10 ? `0${minutes}` : minutes
          let seconds = date.getSeconds() // 取得秒數
          seconds = seconds < 10 ? `0${seconds}` : seconds

          let new_date = ''
          switch (format) {
            case 'ISOS': {
              new_date = date.toISOString()
              break
            }
            case 'YYYYMMDD': {
              new_date = `${year}${delimiter}${month}${delimiter}${day}`
              break
            }

            default: {
              new_date = `${year}${delimiter}${month}${delimiter}${day} ${hours}:${minutes}:${seconds}`
            }
          }

          return new_date
        },

        formatTime: function(dateString, delimiter){
          // 建立新的 Date 物件
          let date = new Date();

          if (dateString) {
            date = new Date(dateString)
          }
          
          // 取得年份
          const year = date.getFullYear();
          
          // 取得月份
          let month = date.getMonth() + 1;
          month = month < 10 ? '0' + month : month;
          
          // 取得日期
          let day = date.getDate();
          day = day < 10 ? '0' + day : day;
          
          // 取得小時
          let hours = date.getHours();
          hours = hours < 10 ? '0' + hours : hours;
          
          // 取得分鐘
          let minutes = date.getMinutes();
          minutes = minutes < 10 ? '0' + minutes : minutes;
          
          // 取得秒數
          let seconds = date.getSeconds();
          seconds = seconds < 10 ? '0' + seconds : seconds;
          
          // 格式化日期和時間
          const formattedDateTime = `${year}${delimiter}${month}${delimiter}${day} ${hours}:${minutes}:${seconds}`;
          
          return formattedDateTime;
        },

        getUTCTime: function(dateString, delimiter){
          // 建立新的 Date 物件
          const date = new Date(dateString);
          
          // 取得年份
          const year = date.getUTCFullYear();
          
          // 取得月份
          let month = date.getUTCMonth() + 1;
          month = month < 10 ? '0' + month : month;
          
          // 取得日期
          let day = date.getUTCDate();
          day = day < 10 ? '0' + day : day;
          
          // 取得小時
          let hours = date.getUTCHours();
          hours = hours < 10 ? '0' + hours : hours;
          
          // 取得分鐘
          let minutes = date.getUTCMinutes();
          minutes = minutes < 10 ? '0' + minutes : minutes;
          
          // 取得秒數
          let seconds = date.getUTCSeconds();
          seconds = seconds < 10 ? '0' + seconds : seconds;
          
          // 格式化日期和時間
          const formattedDateTime = `${year}${delimiter}${month}${delimiter}${day} ${hours}:${minutes}:${seconds}`;
          
          return formattedDateTime;
        },

        getBase64File: async function(url) {
          return await fetch(url).then(
            res => res.arrayBuffer()
          )
        },

        formatNumberWithCommas(number) {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        field_rules: {
          required: value => !!value || '必填欄位',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email格式錯誤'
          },
          isCustomerEmailExist: async function(value) {
            console.log('exist')
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            let result = true
            if (!pattern.test(value)) {
              console.log('?')
              return false
            }
            else {
              console.log('??')
              return result
            }

          },
          verifyId: (id) => {
            id = id.trim();

            let verification = id.match("^[A-Z][12]\\d{8}$")
            if(!verification){
                return '身分證格式錯誤'
            }

            let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
            let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]

            id = String(conver.indexOf(id[0]) + 10) + id.slice(1);

            let checkSum = 0
            for (let i = 0; i < id.length; i++) {
                let c = parseInt(id[i])
                let w = weights[i]
                checkSum += c * w
            }

            if (checkSum % 10 == 0) {
               return  true
            }
            else {
                return '身分證格式錯誤'
            }
          },
          phone: (value) => {
            if (value.length !== 10) {
                return '電話號碼格式錯誤'
            } 
            else {
                if (value.match(/\d/g) && (value.match(/\d/g)).length === 10) {
                    return true
                }
                else {
                    return '電話號碼格式錯誤'
                }
            }
          },
          quantity: (value, type, limit, error_msg) => {
            const types = {
              ['<']: (a, b) => a < b,
              ['<=']: (a, b) => a <= b,
              ['===']: (a, b) => a === b, // 不知道用不用得到
              ['==']: (a, b) => a == b, // 不知道用不用得到
              ['>']: (a, b) => a > b,
              ['>=']: (a, b) => a >= b
            }
            return types[type](value, limit) || error_msg
          },
        },

        makeUrlQuery(url, query_data) {
          if (!url) return ''
          let new_url = url

          const query = new URLSearchParams()
          for (const param in query_data) {
            if (!query_data[param]) continue
            query.append(param, query_data[param])
          }

          if (query.toString()) {
            new_url = `${url}?${query.toString()}`
          }

          return new_url
        },
}